module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('mu-appbar', {
    staticClass: "header",
    attrs: {
      "title": "更多"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('mu-list', [_c('mu-list-item', {
    staticClass: "my-content",
    attrs: {
      "title": "项目API",
      "href": "https://www.vue-js.com/api/"
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "loyalty"
    },
    slot: "left"
  })], 1), _vm._v(" "), _c('mu-list-item', {
    staticClass: "my-content",
    attrs: {
      "title": "项目地址&给个star",
      "href": "https://github.com/Hxvin/vue-home"
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "star"
    },
    slot: "left"
  })], 1)], 1), _vm._v(" "), _c('FooterNav')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-acdbf9d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/more.vue
// module id = 144
// module chunks = 1